import LegalDocumentPage, { type LegalSection } from './legal/LegalDocumentPage';

const sections: LegalSection[] = [
    {
        id: 'aceite',
        title: 'Aceite dos termos',
        children: (
            <>
                <p>
                    Estes Termos de Uso regulam o acesso e uso da plataforma LaudoPsi, operada pela
                    NAPOLI SOFTWARE DEVELOPMENT LTDA, CNPJ 55.764.444/0001-95.
                </p>
                <p>
                    Ao criar conta, acessar, contratar ou utilizar a plataforma, você declara que
                    leu, compreendeu e concorda com estes termos e com a Política de Privacidade.
                </p>
                <p>
                    Se você utiliza o LaudoPsi em nome de uma clínica, consultório, empresa ou
                    instituição, declara possuir poderes para aceitar estes termos em nome dessa
                    organização.
                </p>
            </>
        ),
    },
    {
        id: 'servico',
        title: 'O que é o LaudoPsi',
        children: (
            <>
                <p>
                    O LaudoPsi é uma plataforma SaaS para apoiar psicólogos na gestão de pacientes,
                    coleta de informações, aplicação de questionários e testes digitais, organização
                    de resultados, consulta a referências, elaboração assistida de laudos e
                    exportação de documentos.
                </p>
                <p>
                    O serviço inclui funcionalidades como cadastro de pacientes, editor de laudos,
                    templates, anamneses digitais, testes psicológicos digitais, catálogo SATEPSI,
                    recursos de IA, personalização visual, exportação DOCX, pagamentos e controle de
                    assinatura.
                </p>
                <p>
                    A plataforma é uma ferramenta tecnológica de apoio e produtividade. Ela não
                    presta atendimento psicológico, não substitui avaliação clínica e não exerce
                    atividade privativa de psicólogo.
                </p>
            </>
        ),
    },
    {
        id: 'usuarios',
        title: 'Quem pode usar',
        children: (
            <>
                <p>
                    O LaudoPsi é destinado a psicólogos, neuropsicólogos e profissionais habilitados
                    que atuem com avaliações psicológicas, documentos técnicos e atividades
                    compatíveis com sua formação e registro profissional.
                </p>
                <p>
                    Você é responsável por informar dados verdadeiros, manter seu CRP e informações
                    profissionais atualizadas e utilizar a plataforma de acordo com a legislação,
                    normas do Conselho Federal de Psicologia e demais regras éticas aplicáveis.
                </p>
                <p>
                    Podemos recusar, suspender ou encerrar acesso em caso de uso indevido, violação
                    destes termos, risco de segurança, fraude, inadimplência ou determinação legal.
                </p>
            </>
        ),
    },
    {
        id: 'responsabilidade-profissional',
        title: 'Responsabilidade profissional',
        children: (
            <>
                <p>O psicólogo é exclusivamente responsável por:</p>
                <ul>
                    <li>
                        Coletar dados de pacientes com base legal adequada e observância de deveres
                        éticos.
                    </li>
                    <li>
                        Selecionar testes, instrumentos, questionários e procedimentos compatíveis
                        com o caso concreto.
                    </li>
                    <li>
                        Interpretar resultados, validar hipóteses, revisar textos e decidir o
                        conteúdo final do laudo.
                    </li>
                    <li>
                        Garantir que documentos emitidos estejam de acordo com normas profissionais,
                        científicas e regulatórias aplicáveis.
                    </li>
                    <li>
                        Obter consentimentos, autorizações ou comunicações necessárias quando
                        envolver pacientes, responsáveis legais, instituições ou terceiros.
                    </li>
                </ul>
                <p>
                    A LaudoPsi não se responsabiliza por conclusões clínicas, decisões
                    profissionais, uso inadequado de instrumentos, falhas de interpretação,
                    documentos emitidos pelo usuário ou consequências decorrentes do uso
                    profissional da plataforma.
                </p>
            </>
        ),
    },
    {
        id: 'ia',
        title: 'Uso de inteligência artificial',
        children: (
            <>
                <p>
                    Recursos de IA podem gerar rascunhos, aprimorar textos, consolidar respostas e
                    auxiliar na organização de conteúdo clínico. Esses recursos são probabilísticos
                    e podem produzir informações incompletas, inadequadas ou imprecisas.
                </p>
                <p>
                    Todo conteúdo gerado por IA deve ser revisado, editado e validado pelo
                    profissional antes de uso em qualquer laudo, relatório, recomendação ou
                    comunicação clínica.
                </p>
                <p>
                    A IA não substitui julgamento profissional, entrevista clínica, aplicação
                    adequada de instrumentos, interpretação técnica ou responsabilidade ética do
                    psicólogo.
                </p>
                <p>
                    Você deve evitar inserir dados identificáveis desnecessários em campos livres,
                    prompts e solicitações de IA. O LaudoPsi aplica medidas de desidentificação, mas
                    o uso responsável do profissional continua essencial.
                </p>
            </>
        ),
    },
    {
        id: 'testes-satepsi',
        title: 'Testes psicológicos e SATEPSI',
        children: (
            <>
                <p>
                    O LaudoPsi pode disponibilizar questionários e instrumentos de domínio público
                    ou de uso aberto, quando aplicável, com recursos de cálculo, organização de
                    resultados, tabelas e gráficos para apoiar o fluxo de trabalho.
                </p>
                <p>
                    O LaudoPsi não corrige, replica, distribui ou substitui testes psicológicos
                    protegidos por direitos autorais, propriedade intelectual de editoras, manuais
                    técnicos restritos ou materiais de uso reservado. Para instrumentos
                    proprietários, a plataforma pode apenas oferecer recursos genéricos de
                    organização, importação, registro e apresentação de resultados informados pelo
                    próprio profissional.
                </p>
                <p>
                    O catálogo SATEPSI e eventuais referências exibidas têm finalidade informativa e
                    de apoio. O profissional é responsável por verificar autorização de uso,
                    validade, normas técnicas, adequação ao paciente, aplicação correta e
                    interpretação clínica conforme as regras do CFP, SATEPSI, editoras e legislação
                    aplicável.
                </p>
            </>
        ),
    },
    {
        id: 'pacientes-links',
        title: 'Pacientes, links e terceiros',
        children: (
            <>
                <p>
                    O profissional pode enviar links para pacientes responderem questionários ou
                    testes sem criar conta. O profissional é responsável por compartilhar esses
                    links apenas com pessoas autorizadas e por orientar pacientes sobre finalidade,
                    uso e confidencialidade das respostas.
                </p>
                <p>
                    Pacientes, responsáveis, familiares, instituições ou terceiros que recebam links
                    devem utilizá-los apenas para a finalidade indicada pelo profissional. O uso
                    indevido de links, respostas falsas ou compartilhamento não autorizado pode
                    comprometer o fluxo clínico.
                </p>
                <p>
                    A LaudoPsi poderá aplicar medidas de segurança, expiração, cookies técnicos e
                    limites de acesso para reduzir abuso.
                </p>
            </>
        ),
    },
    {
        id: 'planos-pagamentos',
        title: 'Planos, pagamentos e cancelamento',
        children: (
            <>
                <p>
                    O LaudoPsi pode oferecer camada gratuita, testes, planos pagos, limites de
                    exportação DOCX, limites de IA e outros controles de uso. As condições
                    comerciais aplicáveis serão apresentadas na plataforma, no checkout ou em
                    comunicações oficiais.
                </p>
                <p>
                    Pagamentos, assinaturas, faturas, alteração de plano, cancelamento e dados de
                    cartão são processados por provedor de pagamento, como Stripe. Ao contratar,
                    você também estará sujeito aos termos e políticas desse provedor.
                </p>
                <p>
                    Assinaturas podem renovar automaticamente conforme o ciclo contratado. O
                    cancelamento impede renovações futuras, mas não garante reembolso proporcional
                    de período já iniciado, salvo quando exigido por lei ou indicado expressamente
                    na oferta.
                </p>
                <p>
                    Funcionalidades como exportação DOCX e uso de IA podem ser bloqueadas quando não
                    houver assinatura ativa, quando o limite do plano for atingido, quando houver
                    inadimplência ou quando faltarem dados profissionais obrigatórios, como CRP.
                </p>
            </>
        ),
    },
    {
        id: 'conta-seguranca',
        title: 'Conta e segurança',
        children: (
            <>
                <p>
                    Você é responsável por proteger seu acesso, manter seus dispositivos seguros e
                    notificar imediatamente qualquer suspeita de uso indevido, vazamento de
                    credenciais ou acesso não autorizado.
                </p>
                <p>
                    Não é permitido compartilhar conta, burlar controles de acesso, explorar
                    vulnerabilidades, realizar engenharia reversa indevida, interferir na
                    infraestrutura, automatizar uso abusivo ou tentar acessar dados de terceiros.
                </p>
                <p>
                    Poderemos suspender sessões, exigir reautenticação, bloquear acessos suspeitos
                    ou encerrar contas para proteger usuários, pacientes e a plataforma.
                </p>
            </>
        ),
    },
    {
        id: 'uso-proibido',
        title: 'Usos proibidos',
        children: (
            <>
                <p>Você não deve usar o LaudoPsi para:</p>
                <ul>
                    <li>
                        Praticar atividade profissional sem habilitação, registro ou autorização
                        necessária.
                    </li>
                    <li>
                        Inserir, gerar ou distribuir conteúdo ilícito, discriminatório, fraudulento,
                        ofensivo ou que viole direitos de terceiros.
                    </li>
                    <li>Coletar dados sem base legal, autorização ou finalidade legítima.</li>
                    <li>
                        Usar a IA para produzir documentos sem revisão profissional ou para
                        automatizar decisões clínicas sem supervisão.
                    </li>
                    <li>
                        Tentar violar segurança, disponibilidade, integridade, confidencialidade ou
                        limites técnicos da plataforma.
                    </li>
                    <li>
                        Revender, sublicenciar ou disponibilizar o serviço a terceiros sem
                        autorização.
                    </li>
                </ul>
            </>
        ),
    },
    {
        id: 'propriedade-intelectual',
        title: 'Propriedade intelectual',
        children: (
            <>
                <p>
                    A plataforma, marca LaudoPsi, interfaces, fluxos, código, design, documentação,
                    modelos próprios, textos institucionais e demais elementos protegidos pertencem
                    à LaudoPsi ou a seus licenciantes.
                </p>
                <p>
                    Você mantém direitos sobre dados, conteúdos e documentos inseridos ou produzidos
                    a partir de sua atuação profissional, observados os direitos de pacientes e
                    terceiros. Ao usar a plataforma, concede à LaudoPsi licença limitada para
                    processar esses conteúdos exclusivamente para prestar, proteger e melhorar o
                    serviço, conforme a Política de Privacidade.
                </p>
                <p>
                    Feedbacks, sugestões e ideias enviados poderão ser usados para evolução do
                    produto sem obrigação de remuneração, desde que não contenham dados pessoais ou
                    clínicos desnecessários.
                </p>
            </>
        ),
    },
    {
        id: 'disponibilidade',
        title: 'Disponibilidade e mudanças',
        children: (
            <>
                <p>
                    Buscamos manter o LaudoPsi disponível, seguro e estável, mas o serviço pode
                    sofrer interrupções, lentidão, manutenção, falhas de fornecedores,
                    indisponibilidade de internet, mudanças técnicas ou eventos fora do nosso
                    controle.
                </p>
                <p>
                    Podemos alterar, adicionar, remover ou limitar funcionalidades, planos,
                    integrações, modelos, templates e fluxos para melhorar o produto, atender
                    requisitos legais, corrigir problemas ou preservar segurança.
                </p>
                <p>
                    Quando uma mudança relevante afetar significativamente usuários ativos,
                    buscaremos comunicar por canais apropriados.
                </p>
            </>
        ),
    },
    {
        id: 'limitacao-responsabilidade',
        title: 'Limitação de responsabilidade',
        children: (
            <>
                <p>
                    Na máxima extensão permitida pela legislação aplicável, a LaudoPsi não será
                    responsável por danos indiretos, lucros cessantes, perda de oportunidade, falhas
                    clínicas, decisões profissionais, uso inadequado, conteúdo inserido pelo
                    usuário, indisponibilidade de terceiros ou eventos fora de seu controle
                    razoável.
                </p>
                <p>
                    Nada nestes termos limita responsabilidades que não possam ser limitadas por
                    lei, nem afasta direitos legais obrigatórios do consumidor quando aplicáveis.
                </p>
            </>
        ),
    },
    {
        id: 'privacidade',
        title: 'Privacidade e proteção de dados',
        children: (
            <>
                <p>
                    O tratamento de dados pessoais no LaudoPsi é descrito na Política de
                    Privacidade. Ao usar a plataforma, você deve cumprir a LGPD, normas
                    profissionais e obrigações éticas relacionadas aos dados que inserir ou coletar.
                </p>
                <p>
                    Quando atuar como controlador dos dados de pacientes, o profissional é
                    responsável por definir finalidades, bases legais, deveres de informação,
                    retenção e atendimento aos direitos dos titulares, sem prejuízo das obrigações
                    da LaudoPsi como operadora quando aplicável.
                </p>
            </>
        ),
    },
    {
        id: 'alteracoes',
        title: 'Alterações dos termos',
        children: (
            <>
                <p>
                    Podemos atualizar estes Termos de Uso para refletir mudanças no produto,
                    legislação, fornecedores, planos ou práticas operacionais. A versão vigente
                    estará disponível nesta página.
                </p>
                <p>
                    Se uma alteração material exigir novo aceite, poderemos solicitá-lo dentro da
                    plataforma ou por outro meio apropriado.
                </p>
            </>
        ),
    },
    {
        id: 'lei-contato',
        title: 'Lei aplicável e contato',
        children: (
            <>
                <p>Estes termos são regidos pelas leis da República Federativa do Brasil.</p>
                <p>
                    Dúvidas, solicitações, notificações ou comunicações sobre estes termos devem ser
                    enviadas para contato@laudopsi.com.
                </p>
            </>
        ),
    },
];

export default function TermsOfUse() {
    return (
        <LegalDocumentPage
            title="Termos de Uso"
            description="Regras para uso do LaudoPsi por psicólogos, incluindo responsabilidade profissional, IA assistiva, organização de resultados, assinatura, segurança e limites do serviço."
            updatedAt="28 de abril de 2026"
            version="v1.0"
            sections={sections}
        />
    );
}
